import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-mini-charts-icon',
  templateUrl: 'mini-charts-icon.component.html'
})
export class MiniChartsIconComponent {
  constructor() {}
}
